var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawHandshakeDealNwk6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 914.738,
    height: 880,
    viewBox: "0 0 914.738 880",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-526.865 -118.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 524.931,
    height: 727.78,
    rx: 8,
    transform: "translate(604.509 336.82) rotate(-24.52)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 254.925,
    height: 60.305,
    rx: 8,
    transform: "translate(720.003 263.055) rotate(-24.52)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.408,0H95.754a8.408,8.408,0,0,1,8.408,8.408V95.754a8.408,8.408,0,0,1-8.408,8.408H8.408A8.408,8.408,0,0,1,0,95.754V8.408A8.408,8.408,0,0,1,8.408,0Z",
    transform: "translate(772.899 636.614) rotate(-24.52)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.982,0H137.793a4.982,4.982,0,1,1,0,9.963H4.982A4.982,4.982,0,0,1,4.982,0Z",
    transform: "translate(851.783 393.446) rotate(-24.52)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.982,0H230.763a4.982,4.982,0,1,1,0,9.963H4.982A4.982,4.982,0,0,1,4.982,0Z",
    transform: "translate(857.992 407.042) rotate(-24.52)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.982,0H214.157a4.982,4.982,0,1,1,0,9.963H4.982A4.982,4.982,0,0,1,4.982,0Z",
    transform: "translate(864.184 423.789) rotate(-24.52)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 142.775,
    height: 9.963,
    transform: "translate(943.367 594.213) rotate(-24.52)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 235.744,
    height: 9.963,
    transform: "translate(949.571 607.799) rotate(-24.52)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 219.139,
    height: 9.963,
    transform: "translate(955.767 621.403) rotate(-24.52)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.079,530.727c6.579.386,14.17,15.373,21.219,6.884s6.978-40.841,6.978-40.841L328.6,499.6s-.709,41.372-11.613,50.489-25.276-9.18-32-14.02S283.5,530.341,290.079,530.727Z",
    transform: "translate(531.417 136.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.408,0H324.646a8.408,8.408,0,0,1,8.408,8.408v94.2a8.408,8.408,0,0,1-8.408,8.408H8.408A8.408,8.408,0,0,1,0,102.607V8.408A8.408,8.408,0,0,1,8.408,0Z",
    transform: "translate(925.867 810.135) rotate(-24.52)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045,631.182c-11.645-3.321-23.563-2.69-27.273,10.625-1.251,4.488-1.4,11.456-6.211,13.768-7.083,3.405-15.628-3.405-21.776-6.18-11.456-5.171-23.216-1.65-29.848,9.217-3.363,5.507-4.8,11.845-5.948,18.119-.494,2.722-.557,6.085-1.7,8.649-2.2,4.908-9.07,4.467-13.579,4.277a29.3,29.3,0,0,1-3.006-.221,26.622,26.622,0,0,0,5.045-16.952c-.294-9.953-6.758-20.841-18.056-19.622-10.121,1.051-17.246,10.825-16.111,20.715.967,8.408,6.443,14.924,13.463,18.918-3.447,1.524-7.126,2.711-10.384,4.288a43.563,43.563,0,0,0-4.425,2.47c-9.848-4.75-22.785-5.644-31.645-.8-4.288,2.344-1.156,9.312,3.153,6.947,6.747-3.689,14.188-2.764,21.24-.42l.589.21a18.99,18.99,0,0,0-1.839,2.848c-3.983,7.735,0,19.969,9.69,20.809,13.663,1.167,14.3-16.889,6.884-24.078-.315-.3-.631-.6-.967-.883,3.069-1.482,6.39-2.6,9.322-3.846a38.774,38.774,0,0,0,7.252-4.036l.526.137c10.436,2.365,26.726,3.1,30.478-9.543,3.216-10.972,3.521-34.272,20.862-32.118,7.073.872,12.874,6.306,19.6,8.271,6.022,1.8,12.99,1.871,17.93-2.564,4.078-3.657,4.992-9.059,6.243-14.1.641-2.606,1.272-5.717,3.395-7.578,3.836-3.353,10.173-1.377,14.451-.158C803.074,639.674,805.785,632.527,801.045,631.182Zm-135.576,88.9c-2.3,2.281-4.74.473-5.97-1.913-1.492-2.9-.851-5.759,1.051-8.313a14.449,14.449,0,0,1,1-1.2c4.551,2.943,8.271,7.157,3.962,11.424Zm8.071-56.753c4.729-4.393,11.319-3.426,14.136,2.606s1.576,14.546-2.375,19.863a16.037,16.037,0,0,1-1.734,1.955,22.141,22.141,0,0,1-7.493-4.277c-5.591-5.045-8.755-14.367-2.491-20.179Z",
    transform: "translate(383.909 121.225)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.967,423.018l-93.558,83.153L523.65,371.037,689.967,329.46Z",
    transform: "translate(543.743 127.917)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.745,231.69s30.026,41.577,207.894,31.182L728.59,418.8l69.659,78.371c10.941,12.317,11.561,30.993.82,43.479-6.527,7.578-15.912,11.561-28.9,2.89,0,0,0,51.971-51.971,31.182,0,0-20.788,41.577-62.365,20.788,0,0,0,20.788-31.182,10.394s-197.51-145.518-197.51-145.518L354.38,408.412Z",
    transform: "translate(369.985 100.947)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.887,282.715s-44.919,0-89.333-20.168c-40.389-18.318-87.42-15.985-124.688,8.061-30.373,19.6-56.69,52.055-56.2,105.655,0,0,40.421,41.577,83.153-41.577h31.182s30.026,103.952,114.346,93.537S845.3,407.434,845.3,407.434Z",
    transform: "translate(378.053 101.903)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.456,
    height: 80.852,
    rx: 22.21,
    transform: "translate(868.163 569.994) rotate(45)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.456,
    height: 80.852,
    rx: 22.21,
    transform: "translate(834.66 530.726) rotate(45)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.456,
    height: 88.198,
    rx: 22.21,
    transform: "translate(914.934 595.972) rotate(45)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.933,
    height: 58.802,
    rx: 15.51,
    transform: "translate(945.547 638.136) rotate(45)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.875,448.848l-93.547,41.577L602.77,261.742l83.164-31.182Z",
    transform: "translate(547.776 122.876)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,399.4,201.8,440.975l93.558-228.682L212.191,181.1Z",
    transform: "translate(522.567 120.351)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34,92.09l207.893,93.547L104.676,442.689,9.34,424.258Z",
    transform: "translate(517.525 115.817)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.793,141.54,681.9,235.1,789.364,472.066l100.43-19.377Z",
    transform: "translate(551.81 118.338)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawHandshakeDealNwk6);
export default __webpack_public_path__ + "static/media/undraw_handshake-deal_nwk6.5f909d66d2c7adc985aa953f513221b6.svg";
export { ForwardRef as ReactComponent };